import { CodeData } from "common/codedata/source/CodeDataSource";
import codeDataStore from "common/codedata/store/CodeDataStore";
import message from "common/message/source/MessageSource";
import { toJS } from "mobx";
import React from "react";
import CommonUtil from "utils/CommonUtil";
import ObjectUtil from "utils/ObjectUtil";

export interface UIRadiosProps {
  value?: any;
  valueChanged?: (value: any) => void;
  firstName?: "all" | "none" | "sel" | "select";
  codeData?: CodeData[] | string;
  inline?: boolean;
  readOnly?: boolean;
  space?: string;
  className?: string;
}

export default UIRadios;

function UIRadios({className, codeData, firstName, inline = true, readOnly, space, value, valueChanged}: UIRadiosProps) {
  const [codeDatas, setCodeDatas] = React.useState<CodeData[]>();

  React.useEffect(
    () => {
      if (valueChanged != null && codeDatas != null) {
        valueChanged(firstName != null ? "" : ObjectUtil.undefined);
      }

      if (Array.isArray(toJS(codeData))) {
        setCodeDatas([...(codeData as CodeData[])]);
      } else if (typeof codeData === "string") {
        (async (codeDataKey: string) => {
          setCodeDatas(await codeDataStore.readOnce(codeDataKey));
        })(codeData);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(codeData)]
  );

  if (firstName != null && codeDatas?.findIndex((codeData: CodeData) => codeData.code === "") === -1) {
    codeDatas.splice(0, 0, {
      code: "",
      name: message.get(`common.codeData.firstName.${firstName}`),
    });
  }

  const name = CommonUtil.getUid();

  return (
    <div className={className}>
      {codeDatas?.map((codeData: CodeData, index: number) => {
        const disabled = readOnly === true && codeData.code !== value;

        return (
          <label key={codeData.code} className={ "mgl-10"}>
            <input
              type="radio"
              name={name}
              defaultValue={codeData.code}
              defaultChecked={codeData.code === value}
              disabled={disabled}
              onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
                if (valueChanged != null) {
                  valueChanged(event.target.value);
                }
              }}
            />
            {codeData.name}
          </label>
        );
      })}
    </div>
  );
}
